import { Component, OnInit } from '@angular/core';
import { BasicLink } from 'src/app/models';
import { GoogleService } from 'src/app/services';
import jsonData from '../../data/booths.json';

@Component({
    selector: 'app-connect',
    templateUrl: './connect.component.html',
    styleUrls: ['./connect.component.scss']
})
export class ConnectComponent implements OnInit {
    public data: Array<BasicLink> = jsonData.social_links;

    constructor(
        private googleSvc: GoogleService
    ) { }

    ngOnInit(): void {
    }

    public onLinkClick(link: any): void {
        this.googleSvc.sendGAEventById(6, { category: link.text, label: link.href });
        window.open(link.href);
    }
}
